import React from "react";
import { Link } from "react-router-dom";
import cubixImage from "../../../assets/product-cubix.png";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="cubix-call-to-action-wrapper">
      <div className="" id="callToAction">
        <div
          className="call-to-action-container text-center"
          style={{ backgroundImage: "url('../../assets/bg-pattern.svg')" }}
        >
          <div
            className="position-relative right-side-width"
            style={{ gap: "15px" }}
          >
            <h4 className="title_text">See CUBIX in Action</h4>
            <p className="detail-info">
              Ready to discover how Cubix can transform your warehouse
              operations? Schedule a live demo and experience the power of a
              streamlined, intelligent inventory management solution.
            </p>
            <Link
              to="/connect-with-us"
              className="btn-md btn-dark border-0"
              onClick={scrollHeader}
            >
              Contact Us
            </Link>
          </div>
          <div className="image-container">
            <img src={cubixImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
